import { combineReducers } from 'redux';

// Reducers
import editPolicyReducer from './editPolicy-reducer';

// Combine Reducers
var reducers = combineReducers({
	editPolicy:editPolicyReducer
    //search: searchReducer
    // seatchart: seatchartReducer,
    // checkout: checkoutReducer
});

export default reducers;


// WEBPACK FOOTER //
// ./src/reducers/index.js